import * as locale from "../i18n/locale";

/**
 * List of all countries
 * @type {CountryObj[]}
 */
let countryList = [];

/**
 * Serbia
 * @type {CountryObj}
 */
export const serbia = {
	code: 'SRB',
	url: process.env.REACT_APP_COUNTRY_URL_SRB,
	urlRegExp: process.env.REACT_APP_COUNTRY_URL_REGEXP_SRB,
	defaultLocale: locale.englishUs,
	allowedLocales: [locale.serbianLatin, locale.englishUs],
	customValues: {}
}
countryList.push(serbia);

export default countryList;

// Type definitions
/**
 * @typedef {Object} CountryObj
 * @property {string} code - ISO 3166-1 alpha-3 three-letter uppercase country code (ex: 'SRB')
 * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
 * @property {string} url - Public base URL of the country.
 * @property {string} urlRegExp - Regular expression used to check the public URL of the country.
 * @property {LocaleObj} defaultLocale - Default country locale.
 * @property {LocaleObj[]} allowedLocales - Locales allowed for the country (will show in locale / language change 
 * dropdown).
 * @property {Object} [customValues] - Any other custom values.
 */